import { v4 as uuidv4 } from 'uuid'

/**
 * Cross-context UUID generator.
 *
 * `crypto.randomUUID()` is gated to secure contexts (HTTPS or localhost) in
 * Chromium. On plain HTTP LAN access (e.g. http://192.168.x.x:5173 from a
 * phone), it's undefined and throws — silently breaking any code path that
 * calls it during init. This wrapper falls back to the `uuid` library so
 * UUID generation works regardless of origin scheme.
 */
export function safeUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID()
    } catch {
      // some environments expose the symbol but throw on insecure contexts
    }
  }
  return uuidv4()
}
